import React, { useCallback } from "react";
import Ink from "react-ink";

import * as AuthUtils from "../../../lib/util/AuthUtils";
import { useRedirect, useRouteCheck } from "../../../lib/hook/NavigationHooks";
import { useSelector } from "../../../lib/hook/ReduxHooks";
import Router from "../../../Routing";

const RestrictedModeIndicator = () => {
	const redirect = useRedirect();

	const handleAction = useCallback(
		(e) => {
			e.preventDefault();
			redirect({ location: "/super-login", includeRedirect: true });
		},
		[redirect],
	);

	const { visible } = useSelector(() => ({
		visible: AuthUtils.isRestrictedMode(),
	}));

	const isSuperLogin = useRouteCheck(Router.routes.superLogin);

	return visible && !isSuperLogin ? (
		<button
			className={"RestrictedModeIndicator --visible"}
			onClick={handleAction}
		>
			<Ink />
			<p>
				You are using the portal in a restricted mode. This is because you are a
				super admin and require a more secure login method.
			</p>
			<p>
				<b>To login with full credentials click here...</b>
			</p>
		</button>
	) : (
		<div className={"RestrictedModeIndicator__stub"} />
	);
};

export default RestrictedModeIndicator;
